"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedLiabilityType = void 0;
const isAllowedLiabilityType = (liabilityType, config) => liabilityType.id !== config.ccFeeLiabilityTypeId &&
    liabilityType.utility_types.length === 0 &&
    liabilityType.name !== 'Utilities - General';
exports.isAllowedLiabilityType = isAllowedLiabilityType;
